// src/Utility/action.type.js

export const Type = {
  // Action to add an item to the shopping basket
  ADD_TO_BASKET: "ADD_TO_BASKET",

  // Action to remove an item from the shopping basket
  REMOVE_FROM_BASKET: "REMOVE_FROM_BASKET",
  SET_USER:"SET_USER",
};
